import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../ui';
import Done from '../ui/icons/Done';

interface Props {
  token: string;
}

const TokenDisplay: React.FC<Props> = ({ token }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy token: ', err);
    }
  };

  return (
    <StyledDiv className="flex flex-col gap-y-3">
      <p>
        Your personal access token has been created successfully. Please
        <b> copy it now and store it in a secure location</b> — for security reasons, this token will not be shown
        again. If you lose it, you’ll need to generate a new one.
      </p>
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <p className="text-sm font-mono text-gray-800">{token}</p>
      </div>
      <div className="flex justify-end">
        <StyledButton className="text-sm" roundedEdges="rounded-none" onClick={handleCopy}>
          <div className="flex items-center gap-x-0.5">
            {copied && <Done color="white" />}
            <p>{copied ? 'Copied' : 'Copy'}</p>
          </div>
        </StyledButton>
      </div>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  width: 36rem;
  word-wrap: break-word;
`;

const StyledButton = styled(Button)`
  width: 6rem;
`;

export default TokenDisplay;
